import EventDisplay from "./EventDisplay";

export default EventDisplay;
